import { authApiService } from '@/api/authApiService';
import { ApiResponseType } from '@/types/sharedTypes';
import { InvoiceLinkDetailsType } from '@/types/invoiceVaultTypes';

export type InvoiceLinkActionType = 'revoke' | 'extend' | 'cancel' | 'resolve-dispute';

export const invoiceLinkActionApi = (
  id: string,
  action: InvoiceLinkActionType,
  payload: { resolution?: string } = {}
): Promise<ApiResponseType<InvoiceLinkDetailsType>> => {
  return authApiService.POST(`/invoice-vault/links/${id}/${action}/`, payload);
};
